import * as React from 'react';
import * as Dialog from 'naan/primitives/modals/dialog';

import { Link } from 'react-router-dom';
import { VSpacer } from 'naan/primitives/spacer';
import { VStack } from 'naan/primitives/stack';
import { profileHomePath } from 'components/nav/path-helpers';
import { DialogHtmlContainer } from 'components/ui/dialog-html-container';

import __ from 'core/lib/localization';

export const CouponAppliedDialog = ({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}) => {
  return (
    <DialogHtmlContainer onDismiss={onDismiss}>
      <Dialog.HtmlHeading>
        {__('Coupon applied', 'couponApplied')}
      </Dialog.HtmlHeading>
      <Dialog.Body>
        <VStack>
          <VSpacer size={3} />
          {message}
          <VSpacer size={3} />
          <Dialog.LinkContainer>
            <Link to={profileHomePath()} onClick={onDismiss}>
              {__('Go to your account', 'goToAccount')}
            </Link>
          </Dialog.LinkContainer>
          <VSpacer size={3} />
        </VStack>
      </Dialog.Body>
      <Dialog.ButtonsContainer>
        <Dialog.Button
          fullWidth
          presentation={'teal'}
          onClick={onDismiss}
          label={__('OK', 'ok')}
        />
      </Dialog.ButtonsContainer>
    </DialogHtmlContainer>
  );
};
